import { useAuthData } from 'helpers/auth/auth-interceptor.ts';
import * as Sentry from '@sentry/react';

// React component that syncs authenticated user info with Sentry.
// Must be rendered inside React tree (not during Sentry.init), because we need to use QueryMetaContext inside useAuthData.
export const SentryUserBridge = () => {
  const authData = useAuthData();

  Sentry.setUser({
    email: authData.claims.email,
    username: authData.claims.userName,
  });

  return null;
};
